import {
    useEffect
} from "react";
import {useParams, useNavigate} from "react-router-dom";
import {Grid, Button, Typography} from "@mui/material";
import { buildV3ClientDashboardReportsPath } from '../../services/ClientDashboardV3';

function ClientPlanPreview(props) {
    const isV3 = props?.visualVariant === 'v3'
    let { client_code, clientId } = useParams()
    const navigate = useNavigate();

    useEffect(() => {
		document.title = 'Retail ORBIT: Client Plan Preview'
	}, [])

    return <Grid container className={isV3 ? 'v3-plan-page v3-plan-preview-page' : undefined}>
                <Grid item sx={{marginTop: '15px', padding: 4}} lg={12}>
                    {isV3 && <Typography variant="h5" className="v3-plan-page__heading">Plan Preview</Typography>}
                    <div className={isV3 ? 'v3-plan-page__callout p-6 text-center' : 'bg-blue-50 border border-blue-200 rounded-lg p-6 text-center'}>
                        <h2 className="text-xl font-semibold text-blue-900 mb-2">
                            This Report Has Moved!
                        </h2>
                        <p className="text-blue-700 mb-4">
                            Plan preview reports are now available in the new Reports section.
                        </p>
                        <Button
                            variant="contained"
                            onClick={() => {
                                navigate(isV3 ? buildV3ClientDashboardReportsPath(client_code, clientId) : `/clients/${client_code}/reports-lib/${clientId}`);
                            }}
                        >
                            Go to Reports
                        </Button>
                    </div>
                </Grid>
            </Grid>
}

export default ClientPlanPreview